/* Seitenverhältnis des Videos an das Fenster weitergeben (Hoch- und Querformat) */
(function () {
  'use strict';
  function setzen(v) {
    var w = v.closest('.video-wrapper--modal');
    if (!w || !v.videoWidth || !v.videoHeight) return;
    w.style.setProperty('--ct-vr', v.videoWidth + ' / ' + v.videoHeight);
    w.style.setProperty('--ct-vw', v.videoWidth);
    w.style.setProperty('--ct-vh', v.videoHeight);
  }
  document.addEventListener('loadedmetadata', function (e) {
    if (e.target && e.target.tagName === 'VIDEO') setzen(e.target);
  }, true);
  setInterval(function () {
    document.querySelectorAll('.video-wrapper--modal video').forEach(setzen);
  }, 1000);
})();
